import { render, staticRenderFns } from "./LinhasDoPagamentoDePensaoAlimenticiaTabela.vue?vue&type=template&id=78170a83&scoped=true"
import script from "./LinhasDoPagamentoDePensaoAlimenticiaTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhasDoPagamentoDePensaoAlimenticiaTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhasDoPagamentoDePensaoAlimenticiaTabela.vue?vue&type=style&index=0&id=78170a83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78170a83",
  null
  
)

export default component.exports